import React from "react";
import {
  DataGrid,
  gridPageCountSelector,
  GridPagination,
  GridToolbarContainer,
  GridToolbarExport,
  useGridApiContext,
  useGridSelector
} from "@mui/x-data-grid";
import Box from '@mui/material/Box';
import { DatagridHeaderStyle } from "./DataGridStyles";
import Stack from "@mui/material/Stack";
import { makeStyles } from "@mui/styles";
import MuiPagination from '@mui/material/Pagination';
import { styled } from '@mui/material/styles';


const paginationStyle = makeStyles({
  root: {
    "& .Mui-selected": {
      color: "white",
      backgroundColor: "#17b696",
      '&:hover': {
        backgroundColor: "#17b696",
      },
    },
  }
});

function Pagination({ page, onPageChange }) {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const paginationClass = paginationStyle();

  return (
    <div style={{
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '10px'
    }}>
      <MuiPagination
        shape="rounded"
        className={paginationClass.root}
        color="primary"
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event, newPage - 1);
        }}
      />
    </div>
  );
}

function CustomPagination(props) {
  return <GridPagination ActionsComponent={Pagination} {...props} />;
}

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiTablePagination-displayedRows, .MuiTablePagination-spacer': {
    display: 'none'
  },
  '& .MuiDataGrid-selectedRowCount': {
    display: 'none'
  }
}));

const DatagridPageDori = (props) => {
  const {
    columns,
    rows,
    rowHeight = 52,
    headerHeight = 30,
    setSelectionData,
    selectionData,
    checkboxSelection,
    onCellClick = () => { },
    disableColumnMenu = true,
    showColumnRightBorder = false,
    setSelectionRowData,
    switchRowBackgroundColor = false,
    selectedRowNumber = -1,
    disableSelectionOnClick = false,
    countPerPage = 10,
    emptytabletext,
    showExportButton = false,
    exportFileName = 'Dori X Vision',
    columnVisibilityModel = {}
  } = props;

  const NoRowsOverlay = () => {
    return (
      <Stack
        height="100%"
        sx={{ marginTop: "125px", marginBottom: "-112px" }}
        alignItems="center"
        justifyContent="center"
      >
        {emptytabletext ? emptytabletext : "No data found"}
      </Stack>
    );
  };

  const NoResultsOverlay = () => {
    return (
      <Stack
        height="100%"
        sx={{ marginTop: "125px", marginBottom: "-112px" }}
        alignItems="center"
        justifyContent="center"
      >
        {emptytabletext ? emptytabletext : "No data found"}
      </Stack>
    );
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport
          excelOptions={{ allColumns: true }}
          csvOptions={{ allColumns: true, fileName: exportFileName }}
          printOptions={{ disableToolbarButton: true }}
        />
      </GridToolbarContainer>
    );
  }

  return (
    <Box sx={{
      padding: 0,
      width: "100%",
      height: '100%',
      cursor: 'pointer',
      '& .graybackground': {
        backgroundColor: '#eee',
      },
      '& .row-font-style': {
        fontSize: '14px',
      },
      '& .row-color--even': {
        backgroundColor: '#FAFAFA'
      },
      '& .row-color--odd': {
        backgroundColor: 'white'
      },
      '& .selected-row': {
        backgroundColor: '#eee',
      },
      '& .datagrid-table--header': DatagridHeaderStyle,

    }}>
      <StyledDataGrid
        onCellClick={onCellClick ? (event) => onCellClick(event) : null}
        checkboxSelection={checkboxSelection}
        autoHeight={true}
        disableColumnMenu={disableColumnMenu}
        columns={columns}
        rows={rows}
        rowHeight={rowHeight}
        headerHeight={headerHeight}
        onSelectionModelChange={(ids) => {
          const selectedIDs = new Set(ids);
          const selectedRows = rows.filter((row) => selectedIDs.has(row.id));
          if (setSelectionRowData && setSelectionData) {
            setSelectionRowData(selectedRows)
            setSelectionData(ids);
          }
        }}
        getRowId={(row) => row.id}
        selectionModel={selectionData}
        showColumnRightBorder={showColumnRightBorder}
        // pageSizeOptions={[5, 10, 15, 20]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: countPerPage,
              page: 0
            },
          },
        }}
        components={{
          NoRowsOverlay,
          NoResultsOverlay,
        }}
        slots={{
          toolbar: showExportButton ? CustomToolbar : null,
          pagination: CustomPagination,
        }}
        disableSelectionOnClick={disableSelectionOnClick}
        getRowClassName={(params) => switchRowBackgroundColor && selectedRowNumber === -1
          ? `row-font-style row-color--${params.row.id % 2 === 0 ? 'even' : 'odd'}`
          : switchRowBackgroundColor && selectedRowNumber === params.row.id
            ? `row-font-style row-color--${params.row.id % 2 === 0 ? 'even' : 'odd'} selected-row`
            : 'row-font-style'
        }
        columnVisibilityModel={columnVisibilityModel}
      />
    </Box>
  );
};

export default DatagridPageDori;
